import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import AchievementList from './achievement-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Achievements">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>            
            <Breadcrumb.Item active>Achievements</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <AchievementList />
    </Panel>
  );
};

export default Page;
